import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import React from 'react';
import styled from 'styled-components';

import Icon from '../Icon';
import SnackBar from '../SnackBar';
import IconText from '../styles/IconText';
import PatternGalleryActionBarMenu from './PatternGalleryActionBarMenu';

const ActionBar = styled(BottomNavigation)`

    &.schnoffle-patterngallery-small {
      height: 3rem;
      position: relative;
    }

    & span {
      line-height: 1;
      font-size: 0.8rem;
    }
`;

const StyledMoreButton = styled(BottomNavigationAction)`
    padding-top: 0px;
`;

const PatternGalleryBarSmall =
    ({
        iconMore,
        labelAddToCart,
        labelAddToFavorites,
        labelRemoveFromFavorites,
        labelColoring,
        pattern,
        addToFavorites,
        removeFromFavorites,
        goToPattern,
        removeFavorites,
        query,
        showAddedToFavorites,
        imgSrc,
        sewpatId,
    }) => {
        const handleAddToFavorites = () => {
            addToFavorites(pattern.id);
            showAddedToFavorites(Date.now());
        };

        const handleRemoveFromFavorites = () => {
            removeFromFavorites(pattern.id, sewpatId, query);
        };

        const handleGoToPattern = () => {
            goToPattern(pattern.id, sewpatId, query);
        };

        const FavoritesAction = () => {
            if (removeFavorites !== true) {
                return (<BottomNavigationAction
                    onClick={handleAddToFavorites}
                    label={
                        <IconText>{labelAddToFavorites}</IconText>}
                    value='addtofavorite'
                    icon={<Icon
                        name='icon-heartadd'
                        width='1.5rem'
                        height='1.5rem'
                        iconColor={'blueGrey.700'}
                    />}
                />);
            }
            return (<BottomNavigationAction
                onClick={handleRemoveFromFavorites}
                label={
                    <IconText>{labelRemoveFromFavorites}</IconText>}
                value='removefavorite'
                icon={<Icon
                    name='icon-heartremove'
                    width='1.5rem'
                    height='1.5rem'
                    iconColor={'blueGrey.700'}
                />}
            />);
        };

        return (
            <ActionBar
                className='schnoffle-patterngallery-small'
                showLabels
                value={'null'}
            >
                {FavoritesAction()}
                <StyledMoreButton
                    value='more' icon={
                        <PatternGalleryActionBarMenu
                            patternid={pattern.id}
                            label={iconMore}
                            navigateToPattern={handleGoToPattern}
                            addToFavorites={handleAddToFavorites}
                            pattern={pattern}
                            query={query}
                            imgSrc={imgSrc}
                            sewpatId={sewpatId}
                            labelAddToCart={labelAddToCart}
                        />} component='div'
                />
                <SnackBar />
            </ActionBar>
        );
    };

export default PatternGalleryBarSmall;



// WEBPACK FOOTER //
// ./src/components/patterngalleries/PatternGalleryBarSmall.js